import { Dialog, InputV2 } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { useFirmNotApplicableDescriptions } from '../../../queries/use-firm-not-applicable-descriptions';

type ChecklistItemNotApplicableConfirmProps = {
    isOpen: boolean;
    onClose: () => void;
    handleNotApplicable: (reason: string) => void;
};

function ChecklistItemNotApplicableConfirm({ isOpen, onClose, handleNotApplicable }: ChecklistItemNotApplicableConfirmProps): JSX.Element {
    const [reason, setReason] = useState('');
    const [reasonError, setReasonError] = useState('');

    const notApplicableDescriptionsQuery = useFirmNotApplicableDescriptions();

    function handleReasonChange(value: string): void {
        setReason(value);
        setReasonError('');
    }

    function updateChecklistItem(): void {
        if (!reason) {
            setReasonError('You must provide a reason.');
            return;
        }
        handleNotApplicable(reason);
    }

    useEffect(() => {
        setReason('');
        setReasonError('');
    }, [isOpen]);

    return (
        <Dialog
            description="Do you want to mark this checklist item as Not Applicable? You will need to give a reason as to why."
            onClose={onClose}
            onPrimaryActionClick={updateChecklistItem}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Confirm"
            secondaryAction="Cancel"
            title="Not Applicable"
            type="error"
        >
            <div className="pr-6 pb-5">
                <InputV2
                    type="text"
                    title="Reason"
                    placeholder="Enter your reason"
                    onChange={handleReasonChange}
                    errorMessage={reasonError}
                    value={reason}
                    options={notApplicableDescriptionsQuery.data?.notApplicableDescriptions?.map((d) => d.description) || []}
                    autoFocus
                />
            </div>
        </Dialog>
    );
}

export default ChecklistItemNotApplicableConfirm;
